import Reveal from '../Reveal';

const SectionHeading = ({ number, title, align = 'center', light = false, static: isStatic = false }) => {
  const alignClass = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  const Wrapper = isStatic ? 'div' : Reveal;

  return (
    <Wrapper className={`flex flex-col ${alignClass} mb-14 md:mb-16`}>
      <span
        className={`font-mono text-xs tracking-[0.25em] mb-3 ${
          light ? 'text-paper/40' : 'text-accent'
        }`}
      >
        {number}
      </span>
      <h2
        className={`font-serif text-4xl md:text-5xl font-semibold ${
          light ? 'text-paper' : 'text-ink'
        }`}
      >
        {title}
      </h2>
    </Wrapper>
  );
};

export default SectionHeading;
